module.exports = __webpack_public_path__ + "static/pokoj-nr6-photo01-miniaturka-b7f0f43f4ba551c3ca1bbdb8b7c50984.jpg";